module.exports = __webpack_public_path__ + "static/media/gray_bike.e3d240ae.png";